import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import {Link} from "react-router-dom";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import CallMadeIcon from '@material-ui/icons/CallMade';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Assignment from '@material-ui/icons/Assignment';
import AddToPhotos from "@material-ui/icons/AddToPhotos";
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import BackupIcon from '@material-ui/icons/Backup';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';
import SearchIcon from '@material-ui/icons/Search';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1, MaskDate, MaskCel, formateDate, validateDate, convertDate} from "beaktShared/helpers/masks";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

export default function ConciliacaoLancamentoManual({history, itemEdit, handleVoltar}) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, setValue, handleSubmit, errors, setError, clearError, getValues } = useForm({mode: "onChange"});
    const [loading,setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    useEffect(() => {        
        if (itemEdit != null){
            setValue("autorizacaoUra", itemEdit.autorizacaoUra);
            setValue("dataAutorizacao", formateDate(itemEdit.dataAutorizacao));
            setValue("autorizacao", itemEdit.autorizacao);
            setValue("bandeira", itemEdit.bandeira);
            setValue("valor", transformValueFloattoFormated(itemEdit.valor));
            setValue("qtdParcelas", itemEdit.parcelas);
            setValue("telefone", itemEdit.telefone);
            setValue("codigoCredenciamento", itemEdit.codCredenciamento);
            setitemVoltar(itemEdit);
        }
    }, []);

    const clearForm = () => {
        setValue("autorizacaoUra", "");
        setValue("dataAutorizacao", "");
        setValue("autorizacao", "");
        setValue("bandeira", "");
        setValue("valor", "");
        setValue("qtdParcelas", "1");
        setValue("telefone", "");
        setValue("codigoCredenciamento", "");
    }
    
    const [itemVoltar, setitemVoltar] = React.useState(null);
    const voltar = () => {        
        if (handleVoltar != null)
            handleVoltar(itemVoltar);
        else
            history.push("./ConciliacaoCartao");
    }

    const onSubmit = (data, e) => {        
            
        if (!validateDate(data.dataAutorizacao)) {
            setError("dataAutorizacao", "invaliddate",t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dataAutorizacao")

        var dataAutorizacaoConvertida =convertDate(data.dataAutorizacao);

        let item = {
            franquiaId: session.franquiaId,
            conciliacaoCartaoId: (itemEdit == null ? 0 : itemEdit.conciliacaoCartaoId),
            autorizacaoUra: data.autorizacaoUra,
            autorizacao: data.autorizacao,
            dataAutorizacao: dataAutorizacaoConvertida,
            bandeira: data.bandeira,
            valor: transformValueFormatedtoFloat(data.valor),
            parcelas: parseInt(data.qtdParcelas),
            telefone: data.telefone,
            codCredenciamento: data.codigoCredenciamento,
            statusConciliacao: (itemEdit == null ? 0 : itemEdit.statusConciliacao),
            manual: true
        }

        setloading(true);
        if (itemEdit == null)
        {
            UsePostApi("ConciliacaoCartao/manual/" + session.franquiaId,item).then(result=>{
                setloading(false);  
                if(result.status !== 200 && result.status !== 201)
                {                       
                    showNotification(result.message.message, 'danger');                
                    return false; 
                } 
                clearForm();
                showNotification(t("information_message.registered_successfully"), 'success');                
                return true;                
            });
        }
        else{
            UsePutApi("ConciliacaoCartao", "",item).then(result=>{
                setloading(false);  
                if(result.status !== 200)
                {                       
                    showNotification(result.message, 'danger');                
                    return false; 
                } 
                setitemVoltar(item);
                showNotification(t("information_message.registered_successfully"), 'success');
                return true;                
            });            
        } 
    }

    return (
        <div className="maxContent">                
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>  
                    <div>     
                    {loading && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div> 
                    }                          
                    {notification.show &&
                        <div><br/>
                        <SnackbarContent
                            message={notification.message}
                            color={notification.color}
                            closeNotification={() => setNotification({show:false})}
                            close
                        />
                    </div>}    
                        <GridContainer>                                                    
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <PlaylistAddCheckIcon />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                        {t('conciliation.Card_Reconciliation_Manual_Release')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.autorizacaoUra?true:false}
                                                        label={t('conciliation.authorization_ura')+" *"}
                                                        variant="outlined"
                                                        inputRef={register({required: true})}
                                                        name="autorizacaoUra"
                                                        InputLabelProps={{shrink: true}}                                     
                                                        inputProps={{maxLength: 30}}
                                                    />
                                                    {errors.autorizacaoUra &&<FormHelperText className={classes.labelRootError}>
                                                        <span>{t('label.required')}</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.autorizacao?true:false}
                                                        label={t('label.authorization')+" *"}
                                                        variant="outlined"
                                                        inputRef={register({required: true})}
                                                        name="autorizacao"
                                                        InputLabelProps={{shrink: true}}                                     
                                                        inputProps={{maxLength: 30}}
                                                    />
                                                    {errors.autorizacao &&<FormHelperText className={classes.labelRootError}>
                                                        <span>{t('label.required')}</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>                               
                                                    <TextField                                        
                                                        error={errors.dataAutorizacao?true:false}
                                                        label={t('conciliation.authorization_date')+" *"}
                                                        variant="outlined"                                    
                                                        inputRef={register({required: t('label.required')})}
                                                        name="dataAutorizacao"
                                                        defaultValue="" 
                                                        InputLabelProps={{shrink: true}}   
                                                        InputProps={{ inputComponent: MaskDate }}                        
                                                    />
                                                    {errors.dataAutorizacao &&<FormHelperText className={classes.labelRootError}>
                                                        <span>{errors.dataAutorizacao.message}</span>
                                                    </FormHelperText>} 
                                                </FormControl>  
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.bandeira?true:false}
                                                        label={t('label.flag')+" *"}
                                                        variant="outlined"
                                                        inputRef={register({required: true})}
                                                        name="bandeira"
                                                        InputLabelProps={{shrink: true}}                                     
                                                        inputProps={{maxLength: 80}}
                                                    />
                                                    {errors.bandeira &&<FormHelperText className={classes.labelRootError}>
                                                        <span>{t('label.required')}</span>
                                                    </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>   
                                                    <TextField          
                                                        variant="outlined"   
                                                        InputLabelProps={{shrink: true}}  
                                                        label={t('label.value')+" *"}                                                         
                                                        name="valor"        
                                                        inputRef={register({required: true})}  
                                                        error={errors.valor?true:false}  
                                                        defaultValue={''} 
                                                        InputProps={{ inputComponent: MaskMoney }}  
                                                    />
                                                    {errors.valor &&<FormHelperText className={classes.labelRootError}>
                                                        <span> {t('label.required')} </span>
                                                    </FormHelperText> }  
                                                </FormControl>  
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>   
                                                    <TextField
                                                        fullWidth
                                                        label={t('label.parcels')+" *"}
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}} 
                                                        name="qtdParcelas"                  
                                                        defaultValue={1}      
                                                        type="number"                                                 
                                                        inputProps={{maxLength: 3}} 
                                                        onInput={(e) => MaskOnlyNumbersStart1(e) }          
                                                        inputRef={register({required: true})}
                                                        error={errors.qtdParcelas?true:false} 
                                                    />                                
                                                    {errors.qtdParcelas &&
                                                    <FormHelperText> <span className="obg">{t('label.required')}</span>
                                                    </FormHelperText> }
                                                </FormControl>   
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>   
                                                    <TextField
                                                        error={errors.telefone?true:false}
                                                        fullWidth
                                                        label={t('label.telephone')+" *"}
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}} 
                                                        name="telefone"                  
                                                        InputProps={{ inputComponent: MaskCel }} 
                                                        inputProps={{maxLength: 20}}
                                                        inputRef={register({required: true})}                                                        
                                                    />                                
                                                    {errors.telefone &&
                                                    <FormHelperText> <span className="obg">{t('label.required')}</span>
                                                    </FormHelperText> }
                                                </FormControl>   
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>   
                                                    <TextField
                                                        error={errors.codigoCredenciamento?true:false}
                                                        fullWidth
                                                        label={t('conciliation.accreditation_code')+" *"}
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}} 
                                                        name="codigoCredenciamento"           
                                                        inputProps={{maxLength: 30}}                                                                       
                                                        inputRef={register({required: true})}                                                        
                                                    />                                
                                                    {errors.codigoCredenciamento &&
                                                    <FormHelperText> <span className="obg">{t('label.required')}</span>
                                                    </FormHelperText> }
                                                </FormControl>   
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <center>                                                    
                                                    <Button round className={classes.updateProfileButton}
                                                    onClick={e => voltar()} >
                                                        {t('label.return')}
                                                    </Button>                                                    
                                                    <Button round type="submit" color="primary" className={classes.updateProfileButton}>
                                                    {t('button.to_save')}
                                                        {loading && <div>...{t('label.loading')}</div>}
                                                    </Button>
                                                </center>
                                            </GridItem>                                                                                                                 
                                        </GridContainer>  
                                    </CardBody>
                                </Card>
                            </GridItem>                                                                                                                                          
                        </GridContainer>                              
                    </div>
                </div>       
            </form>
        </div>
    );
}